export { RelatorioSinteticoQuantitativo } from './relatorio-sintetico-quantitativo/RelatorioSinteticoQuantitativo'
export { RelatoriosReceitas } from './relatorios-receitas/RelatoriosReceitas'
export { RelatoriosAnaliticos } from './relatorios-analiticos/RelatoriosAnaliticos'
export { default as RelatoriosAcessos  } from './relatorios-acessos/RelatoriosAcessos'
